import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Chatbot from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';

import { config, MessageParser, ActionProvider } from "./chatbot";

import StartPage from "./StartPage";
import Onboarding from "./Onboarding";

import './index.css';
import './App.css';

function ChatbotPage() {
  return (
    <div className="h-screen w-full bg-[#282c34]">
      <div className="chatbot-container">
        <Chatbot
          config={config}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
          placeholderText='Input placeholder'
        />
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/chat" element={<ChatbotPage />} />

        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="/build/index.html" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

